const DATE_TIME: Intl.DateTimeFormatOptions = {
  weekday: "short",
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

const TIME_ONLY: Intl.DateTimeFormatOptions = { hour: "2-digit", minute: "2-digit" };

const MINUTE_MS = 60 * 1000;
const HOUR_MIN = 60;
const DAY_MIN = 24 * HOUR_MIN;

const parseWallTime = (value?: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const validZone = (zone?: string) => {
  if (!zone) return undefined;
  try {
    new Intl.DateTimeFormat(undefined, { timeZone: zone });
    return zone;
  } catch {
    return undefined;
  }
};

export const formatMoment = (value: string | number | null | undefined, locale: string, zone?: string) => {
  if (value === null || value === undefined || value === "") return "";
  const date = typeof value === "number" ? new Date(value) : parseWallTime(value);
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(locale, {
    ...DATE_TIME,
    ...(typeof value === "number" ? { timeZone: validZone(zone) } : {}),
  });
};

export const formatDuration = (minutes: number) => {
  if (!Number.isFinite(minutes) || minutes <= 0) return "";
  const days = Math.floor(minutes / DAY_MIN);
  const hours = Math.floor((minutes % DAY_MIN) / HOUR_MIN);
  const mins = Math.round(minutes % HOUR_MIN);
  return [days ? `${days} d` : "", hours ? `${hours} h` : "", mins ? `${mins} min` : ""]
    .filter(Boolean)
    .join(" ");
};

export const formatAssignmentRange = (start: string | undefined, end: string | undefined, locale: string) => {
  const from = parseWallTime(start);
  const to = parseWallTime(end);
  if (!from || !to) return { range: [formatMoment(start, locale), formatMoment(end, locale)].filter(Boolean).join(" → "), duration: "" };
  const sameDay = from.toDateString() === to.toDateString();
  const range = sameDay
    ? `${from.toLocaleString(locale, DATE_TIME)} → ${to.toLocaleTimeString(locale, TIME_ONLY)}`
    : `${from.toLocaleString(locale, DATE_TIME)} → ${to.toLocaleString(locale, DATE_TIME)}`;
  return { range, duration: formatDuration((to.getTime() - from.getTime()) / MINUTE_MS) };
};

export const safeImageUrl = (value?: string | null) =>
  value && /^https?:\/\//i.test(value) ? value : null;
